import { apiEndpoint } from './apiEndpoint';
import { standardHeaders } from './standardHeaders';

export async function deleteClient(clientId: string) {
	const response = await fetch(`${apiEndpoint}/clients/${clientId}`, {
		method: 'DELETE',
		headers: await standardHeaders(),
		mode: 'cors'
	});
	if (response.ok) {
		return await response.json();
	}
	return null;
}